import ApiCaller from 'actions/ApiCaller';
import baseAjaxConfig from 'actions/BaseAjaxConfig';
import get from 'lodash/get';
export var incidentActionsEnum;
(function (incidentActionsEnum) {
    incidentActionsEnum["SEND_INCIDENT_REQUEST"] = "SEND_INCIDENT_REQUEST";
    incidentActionsEnum["SEND_INCIDENT_REQUEST_SUCCESS"] = "SEND_INCIDENT_REQUEST_SUCCESS";
    incidentActionsEnum["SEND_INCIDENT_REQUEST_ERROR"] = "SEND_INCIDENT_REQUEST_ERROR";
    incidentActionsEnum["RESET_INCIDENT_MODAL"] = "RESET_INCIDENT_MODAL";
})(incidentActionsEnum || (incidentActionsEnum = {}));
export function submitIncident({ id, message }) {
    return (dispatch) => {
        dispatch({ type: incidentActionsEnum.SEND_INCIDENT_REQUEST });
        return ApiCaller.get(Object.assign({}, baseAjaxConfig, {
            pathname: `/api/1/self-serve/helpcenter/incident/update/${id}`,
            action: incidentActionsEnum.SEND_INCIDENT_REQUEST
        }, { query: { text: message } })).then(data => {
            if (get(data.RESPONSE, ['incidentUpdated'])) {
                dispatch({
                    type: incidentActionsEnum.SEND_INCIDENT_REQUEST_SUCCESS,
                    data: data.RESPONSE
                });
            }
            else {
                dispatch({
                    type: incidentActionsEnum.SEND_INCIDENT_REQUEST_ERROR,
                    error: data.RESPONSE
                });
            }
        }, error => {
            dispatch({ type: incidentActionsEnum.SEND_INCIDENT_REQUEST_ERROR, error });
        });
    };
}
export function resetIncidentModal() {
    return (dispatch) => {
        dispatch({ type: incidentActionsEnum.RESET_INCIDENT_MODAL });
    };
}
